import React from 'react';
import { Box } from '@mui/material';
import { AssessmentAccordion } from '../../../../Assessment';
import {
  InformationDisplayBlock,
  type InformationDisplayBlockProps,
} from '../../../../../components';
import {
  QualificationValidationBlock,
  type QualificationValidationBlockProps,
} from './QualificationValidationBlock';

export type QualificationItemProps = {
  title?: string;
  informationDisplayProps: InformationDisplayBlockProps;
  qualificationValidationProps: QualificationValidationBlockProps;
  index: number;
};

export const QualificationItem: React.FunctionComponent<
  QualificationItemProps
> = props => {
  const {
    informationDisplayProps,
    qualificationValidationProps,
    index,
    title = '',
  } = props;

  return (
    <AssessmentAccordion
      key={index}
      className="pl-3"
      title={title}
      defaultExpanded
      AssessDetails={
        <div>
          <Box
            padding={3}
            fontSize={16}
            sx={{
              backgroundColor: '#eeeeee',
              marginBottom: '1rem',
            }}
          >
            <InformationDisplayBlock {...informationDisplayProps} />
          </Box>
          <QualificationValidationBlock {...qualificationValidationProps} />
        </div>
      }
    />
  );
};
